<ion-header>
  <div #tabsRef class="px-3">
    <tablesready-tabs
      [tabs]="tabs"
      [activeTab]="activeTab"
      [disabled]="disabledTabs"
      (changeTab)="onChangeTab($event)"
    ></tablesready-tabs>
  </div>
</ion-header>

<ion-content [style.max-height]="'calc(100% - ' + tabsRef.offsetHeight + 'px'" [forceOverscroll]="false">
  <router-outlet></router-outlet>
</ion-content>
